export default __webpack_public_path__ + "static/media/Solo Queue vs Clash Games Picked.2640c918.png";